export const PrintDeadItemTHeadLayout = () => {
	return (
		<div className="grid grid-cols-12 font-semibold">
			<div className="col-span-2 border border-zinc-200 p-1" />
			<div className="col-span-8 border border-zinc-200 p-1">
				<p>名称</p>
			</div>
			<div className="col-span-2 border border-zinc-200 p-1">
				<p>キャンセル金額</p>
			</div>
		</div>
	);
};
